import {createAsyncThunk} from '@reduxjs/toolkit';
import apiInstance from '../../Apis/Axios';
import {ATTENDANCE_SERVICE} from '../EndPoints';


// Attendance Color
export const GetAttendanceColor = createAsyncThunk("attendanceConfig/getAttendanceColor",async (params, { dispatch, getState }) => {

    const response = await apiInstance.get(`${ATTENDANCE_SERVICE.getAttendanceColor}`, {overlay: false}).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const UpdateAttendanceColor = createAsyncThunk("attendanceConfig/updateAttendanceColor",async (params, { dispatch, getState }) => {

    const response = await apiInstance.put(`${ATTENDANCE_SERVICE.updateAttendanceColor}`, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const ResetToDefaultAttendanceColor = createAsyncThunk("attendanceConfig/resetToDefaultAttendanceColor",async (params, { dispatch, getState }) => {

    const response = await apiInstance.put(`${ATTENDANCE_SERVICE.resetToDefaultAttendanceColor}`, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});


// Attendance Cycle
export const GetAttendanceCycleConfig = createAsyncThunk("attendanceConfig/getAttendanceCycleConfig",async (params, { dispatch, getState }) => {

    const response = await apiInstance.get(`${ATTENDANCE_SERVICE.getAttendanceCycleConfig}`).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const UpdateAttendanceCycleConfig = createAsyncThunk("attendanceConfig/updateAttendanceCycleConfig",async (params, { dispatch, getState }) => {

    const response = await apiInstance.put(`${ATTENDANCE_SERVICE.updateAttendanceCycleConfig}`, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

